import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PAYOUT_ACCOUNT } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// API: POST /api/v1/payment/settlements/request
// body: { provider_type, order_type, payment_method, account_details, settlement_amount, notes? }
export const submitSettlementRequestReducer = createAsyncThunk(
  ACTION_PAYOUT_ACCOUNT.submit_settlement_request,
  async (payload, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.submitSettlementRequest}`,
        { provider_type: "nurse", ...payload }
      );
      if (response?.data?.status === true || response?.status === 200 || response?.status === 201) {
        toast.success(i18n.t("toast.withdrawalRequestSubmitted"));
        return response.data.data;
      }
      const message = response?.data?.message || i18n.t("toast.failedToSubmitWithdrawalRequest");
      toast.error(message);
      return rejectWithValue(message);
    } catch (error) {
      const message = error?.response?.data?.message || i18n.t("toast.failedToSubmitWithdrawalRequest");
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);
